import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Container, FormField, Input, Select, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import ReactJsonView from '@microlink/react-json-view';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../commons/functions';

export const SystemTables = () => {
    const { menu, parameters } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();
    const [selectedTable, setSelectedTable] = React.useState("");
    const [data, setData] = React.useState(null);
    const [id, setId] = React.useState(null);



    const tables = [
        { value: "", label: "Seleccione" },
        { value: "movements", label: "Movimientos" },
        { value: "bookings", label: "Reservas" },
        { value: "equipments", label: "Material" },
        { value: "flights", label: "Vuelos" },
    ]

    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/tables/data',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ table: selectedTable, id: id })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            if (dataWeb && dataWeb.data) {

                setData(dataWeb.data);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s" direction="vertical">
                    <Header variant="h1" actions={<Favorites />}>Tablas</Header>

                    <SpaceBetween size="s" direction="horizontal">
                        <FormField label="Recurso">
                            <Select
                                options={tables}
                                onChange={(e) => {
                                    setSelectedTable(e.detail.selectedOption.value)

                                    setId(null);
                                }}
                                selectedOption={tables.find((e) => e.value == selectedTable)}
                            />
                        </FormField>
                        <FormField label="Identificador">
                            <Input
                                disabled={selectedTable === ""}
                                type="number" value={!!id ? id.toString() : ""} onChange={(e) => {
                                    if (isNaN(parseInt(e.detail.value))) {
                                        setId(null);
                                    } else {
                                        setId(parseInt(e.detail.value))
                                    }
                                }}
                            />

                        </FormField>
                        <FormField label={'\u00A0'}>
                            <Button disabled={selectedTable === "" || !id} variant="primary" onClick={handleRefresh}>Buscar</Button>
                        </FormField>


                    </SpaceBetween>
                    {data && (
                        <Container>
                            <ReactJsonView src={data}
                                theme={parameters.theme === "light" ? "rjv-default" : "ashes"}
                                name={false}
                                style={{ minHeight: 300 }}
                                //collapsed={1}
                                //collapseStringsAfterLength={30}
                                //groupArraysAfterLength={10}
                                displayObjectSize={false}
                                displayDataTypes={false}
                                enableClipboard={false}
                            />
                        </Container>
                    )}
                </SpaceBetween>
            }
        />
    )
};
